var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.358 17.782 33.24 3.9a1.846 1.846 0 0 0 0-2.588 1.846 1.846 0 0 0-2.588 0L16.77 15.429 3.123 1.547a1.846 1.846 0 0 0-2.589 0 1.846 1.846 0 0 0 0 2.588l13.883 13.883L.534 31.664a1.846 1.846 0 0 0 0 2.588 1.846 1.846 0 0 0 2.589 0L17.005 20.37l13.882 13.883a1.846 1.846 0 0 0 2.588 0 1.846 1.846 0 0 0 0-2.588z"
  })));
};
export default SvgClose;